import React from 'react';
import { connect } from 'react-redux';
import DetailView from './DetailView';
import OpinionsView from './OpinionsView';
import MobileWrapper from '../gui/MobileWrapper';
import { setDish } from '../gui/actions';
import * as _ from 'lodash';
import importAllImages from '../assets/functions/importAllImages';
import ratingToStars from '../assets/functions/ratingToStars';
import ratingSumToStars from '../assets/functions/ratingSumToStars';
import getImage from '../assets/functions/getImage';
import Tabs from 'antd/lib/tabs';
import 'antd/lib/tabs/style/css';

const TabPane = Tabs.TabPane;

const images = importAllImages(require.context('../assets/img/dishes', false, /\.(png|jpe?g|svg)$/));

class DetailContainer extends React.Component {

	componentDidMount() {
		const emptyState = _.isEmpty(this.props.dish);
		if (emptyState) {
			const dish = this.getDish()
			this.props.setDish(dish)
		}
	}

	getDish() {
		const indexOfDish = Number(this.props.params.id);
		const { allDishes } = this.props;
		for (let i in allDishes) {
			if (allDishes[i].image === indexOfDish) {
				return allDishes[i];
			}
		}
	}

	mapBenefits(benefits) {
		if (benefits !== undefined) {
			return (
				<div className="benefits">
					<p>Gesund weil</p>
					{benefits.map((single, i) =>
						<ul key={i}>
							<li>
								{single}
							</li>
						</ul>)}
				</div>
				)		
		} else {
			return <div></div>;
		}
	}

	mapOpinions(opinions) {
		if (opinions !== undefined) {
			return opinions.map((single, i) =>
				<div key={i} className="opinions__single">
					<div className="opinions__author">
						<span>{single.name}</span>
						<span>{single.date}</span>
						<span>{ratingToStars(single.rating, 'main-color')}</span>
					</div>
					<p className="opinions__title">{single.title}</p>
					<p className="opinions__content">{single.content}</p>
				</div>
			)
		}
	}

	render() {
		const { dish, warnings } = this.props;
		return (
			<div>
				<MobileWrapper back>
					{dish &&
						<Tabs defaultActiveKey="1" className={'tabs-full-width--2'}>
					    <TabPane tab="Details" key="1">
					    	<DetailView
									img={getImage({dish, images})}
									name={dish.name}
									desc={dish.desc}
									ingredients={dish.ingredients}
									benefits={this.mapBenefits(dish.benefits)}
									warnings={warnings} />
					    </TabPane>
					    <TabPane tab="Meinungen" key="2">
					    	<OpinionsView
									opinions={this.mapOpinions(dish.opinions)}
									averageStars={ratingSumToStars(dish.opinions, 'small-text')} />
					    </TabPane>
					  </Tabs>
					}
				</MobileWrapper>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	dish: state.gui.dish,
	allDishes: state.gui.allDishes,
	warnings: state.gui.warnings,
})

const mapDispatchToProps = dispatch => ({
	dispatch,
	setDish(obj) {
    dispatch(setDish(obj))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DetailContainer);

// export default DetailContainer;


// WEBPACK FOOTER //
// ./src/detail/DetailContainer.js